import { ElementType, ReactNode } from 'react';
import { AlertBox } from '@iwoca/orion';
import clsx from 'clsx';
import styles from './InfoCard.module.css';

type TProps = {
  title?: string;
  children: ReactNode;
  icon: ElementType;
  className?: string;
};

export const InfoCard = ({
  title,
  children,
  icon: Icon,
  className,
}: TProps) => {
  return (
    <AlertBox className={clsx(styles.container, className)} variant="connect">
      <Icon fontSize={20} className={styles.infoIcon} />
      <div className={styles.content}>
        {title && <h3>{title}</h3>}
        <div className={styles.message}>{children}</div>
      </div>
    </AlertBox>
  );
};
